<template>
  <transition name="message">
    <section v-if="message" class="msg-wrapper txt">
      {{ message }}
    </section>
  </transition>
</template>

<script>
export default {
  name: 'message',
  data () {
    return {
      message: ''
    }
  },
  methods: {
    open (msg, duration, cb) {
      this.message = msg
      setTimeout(() => {
        this.message = ''
        setTimeout(() => { cb() }, 300)
      }, duration)
    }
  }
}
</script>

<style lang="less" scoped>
.message-enter-active,.message-leave-active{
  transition: all .5s ease-in-out;
}

.message-enter, .message-leave-to{
  opacity: 0;
  transform: translateY(-20px);
}

.message-leave, .message-enter-to{
  opacity: 1;

}

.msg-wrapper{
  box-sizing: border-box;
  position: fixed;
  left: 50%;
  top: 50%;
  transform-origin: center;
  transform: translate(-50%, -50%);
  z-index: 100;
  color: white;
  font-size: 40px;
  line-height: 1;
  font-weight: 400;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 14px 24px;
  border-radius: 10px;
  color: #fff;
  font-size: 16px;
  min-height: 50px;
  min-width: 173px;
  max-width: 358px;
  line-height: 26px;
  background: rgba(0, 0, 0, 0.85);
  text-align: center;
}
</style>
